import type { ReactNode } from "react";
import { BellOffIcon } from "lucide-react";
import { EmptyState } from "@ibada/ui";

type NotificationEmptyStateProps = {
  title: string;
  description: string;
  action?: ReactNode;
  compact?: boolean;
  tone?: "neutral" | "danger";
  className?: string;
};

export function NotificationEmptyState({
  title,
  description,
  action,
  compact = false,
  tone = "neutral",
  className,
}: NotificationEmptyStateProps) {
  return (
    <EmptyState
      className={className}
      compact={compact}
      surface={!compact}
      tone={tone}
      title={title}
      description={description}
      action={action}
      icon={<BellOffIcon className="size-4" />}
    />
  );
}
